import { makeStyles, Theme } from '@material-ui/core/styles';

export const useLayoutFormStyles = makeStyles((theme: Theme) => ({
    container: {
        justifyContent: 'center',
        alignItems: 'stretch',
    },
    formContainer: {
        marginTop: '94px',
        maxWidth: '420px',
        width: '100%',
        color: theme.palette.primary.main,
    },
}));
